module.exports = __webpack_public_path__ + "static/media/Client.9b3dc74e.png";